<style lang="scss">
    @import '~@/abstracts/_variables.scss';

    div.fullscreen-loader {
        position: absolute;
        min-height: calc(100vh - 25px);
        width: 100%;
        background: #e9e9e9;
        opacity: 0.5;
        z-index: 99;

        svg {
            display: block;
            margin: 0 auto;
            position: absolute;
            top: calc(50% - 50px);
            left: calc(50% - 50px);

            //position: absolute;
            //top: 47.3%;
            //left: 47.3%;
            //right: 0;
            //bottom: 0;
        }

        svg path,
        svg rect {
            fill: $secondary-color;
        }
    }
</style>

<template>
    <div class="fullscreen-loader">
        <svg version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="100px" height="100px" viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;" xml:space="preserve">
          <path fill="#000" d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z">
            <animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="0.6s" repeatCount="indefinite"/>
          </path>
        </svg>
    </div>
</template>

<script>
    export default {

    }
</script>
